import { fetchProfilingCodesByTypeAndMarket } from 'legacy/lut/services/profiling/codes'

import { Market } from 'clickNgo/configs/geo'
import { IPartnerFlag } from 'clickNgo/entities/partner/models/partnerFlag'

import { ProfilingCodeType } from '../model/types'

interface IFetchAvailableProfilingCodesParams {
  market: Market
  partnerFlags: IPartnerFlag[]
  type: ProfilingCodeType.Accreditation | ProfilingCodeType.Program
}

export const fetchAvailableProfilingCodes = async ({
  partnerFlags,
  type,
  market,
}: IFetchAvailableProfilingCodesParams) => {
  const profilingCodeList = await fetchProfilingCodesByTypeAndMarket(
    { type, market },
    { cacheKey: type + market }
  )

  return profilingCodeList.filter(
    (profilingCode) => !partnerFlags.find((flag) => profilingCode.code === flag.code)
  )
}
